import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { CountBadgeModule } from '../count-badge/count-badge.module';
import { NotificationBellComponent } from './notification-bell.component';

@NgModule({
  declarations: [
    NotificationBellComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbDropdownModule,
    CountBadgeModule,
  ],
  exports: [
    NotificationBellComponent
  ],
})
export class NotificationBellModule { }
